import {Model} from 'vue-mc'

export default class User extends Model {
  defaults() {
    return {
      id: null,
      external_id: null,
      email: null,
      name: null,
      first_name: null,
      middle_name: null,
      last_name: null,
      avatar_url: null,
      is_admin: false,
      is_manager: false,
      face: 0,
      language: {},
      download_high_resolution: false,
      custom_field_values_attributes: []
    }
  }

  signed() {
    return (this.id !== null)
  }

  signIn(params) {
    return this.createRequest({
      method: 'POST',
      url: `/api/v2/auth/sign_in`,
      data: {user: params}
    }).send()
  }

  signUp(params) {
    return this.createRequest({
      method: 'POST',
      url: `/api/v2/auth`,
      data: {user: params}
    }).send()
  }

  hasAdminAccess() {
    return (this.id && this.is_admin === true);
  }

  hasSaleAccess() {
    return (this.id && this.role === 'sale');
  }

  hasAdminOrManagerAccess() {
    return (this.id && (this.is_admin === true || this.is_manager === true));
  }  

  hasPhotographerAccess() {
    return (this.id && this.role === 'photographer');
  }

  downloadFullResolution() {
    return (this.id && this.download_high_resolution);
  }  

  async updateAvatar(params){
    return this.createRequest({
      method: 'PUT',
      url: `/api/v2/users/update_profile`,
      data: {user: params}
    }).send()
  }

  update(params) {
    return this.createRequest({
      method: 'PUT',
      url: `/api/v2/users/update_profile`,
      data: {user: params}
    }).send()
  }

  fetch() {
    return this.createRequest({
      method: 'GET',
      url: `/api/v2/users/signed`
    }).send()
  }

  setLanguage(language) {
    return this.createRequest({
      method: 'POST',
      url: `/api/v2/users/set_language`,
      params: {language: language}
    }).send()
  }
}
